<template>
  <div id="container" class="mainBox">
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
      <nyTit pathUrl='/plant' />
      <div class="content">
        <!-- 左 -->
        <div class="left">

        </div>
        <!-- 中 -->
        <div class="middle"><img src="../assets/img/fuwu/zj.png" /> </div>
        <!-- 右 -->
         <div class="right">

        </div>
      </div>

  </div>
  <div class="footer">本产品由来村网提供技术支持</div>
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";
import nyTit from "@/components/nyTit.vue";
import leftBar2 from "../components/suyuan/leftBar2.vue";
import leftBar1 from "../components/suyuan/leftBar1.vue";
import rightLine from "@/components/suyuan/rightLine.vue";
import countTo from "@/components/vue-count-to/src/vue-countTo.vue";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";



    // const timer = ref(null);
    const router = useRouter();

    const state = reactive({
      leftData1:[],
      leftData2:[{name:"累计查询人数",value:3000,unit:"人"},{name:"累计查询次数",value:6000,unit:"次"}],
      config: {
        header: [
          '<span style="color:#fff;">抽检时间</span>',
          '<span style="color:#fff;">品种</span>',
          '<span style="color:#fff;">批次</span>',
          '<span style="color:#fff;">基数</span>',
          '<span style="color:#fff;">合格率</span>',
        ],

        data: [
          ["2024.3.1", "小麦", "20230301BATCH001", "30", "<span style='color:#00FFBA;'>100%</span>"],
          ["2024.3.1", "玉米", "20230301BATCH001", "30", "<span style='color:#00FFBA;'>100%</span>"],
          ["2024.3.1", "大豆", "20230301BATCH001", "30", "<span style='color:#00FFBA;'>100%</span>"],
          ["2024.3.1", "花生", "20230301BATCH001", "30", "<span style='color:#00FFBA;'>100%</span>"],
          ["2024.3.1", "小麦", "20230301BATCH001", "30", "<span style='color:#00FFBA;'>100%</span>"],
          ["2024.3.1", "花生", "20230301BATCH001", "30", "<span style='color:#00FFBA;'>100%</span>"],
          ["2024.3.1", "大豆", "20230301BATCH001", "30", "<span style='color:#00FFBA;'>100%</span>"],
          ["2024.3.1", "小麦", "20230301BATCH001", "30", "<span style='color:#00FFBA;'>100%</span>"],
        ],
        headerBGC:"",
        oddRowBGC: "",
        evenRowBGC: "",
        index: false,
        columnWidth: [200],
        align: ["center"],
        headerHeight:90,
        rowNum:7
      },
      plant: [
        {name: "地块1", img: require("@/assets/img/nysy/sym1.png")},
        {name: "地块2",img: require("@/assets/img/nysy/sym2.png") },
        {name: "地块3", img: require("@/assets/img/nysy/sym3.png") },
        {name: "地块4",img: require("@/assets/img/nysy/sym4.png")},
        {name: "地块5", img: require("@/assets/img/nysy/sym5.png")},
        {name: "地块6",img: require("@/assets/img/nysy/sym6.png")},
        {name: "地块1", img: require("@/assets/img/nysy/sym1.png")},
        {name: "地块2",img: require("@/assets/img/nysy/sym2.png") },
        {name: "地块3", img: require("@/assets/img/nysy/sym3.png") },
        {name: "地块4",img: require("@/assets/img/nysy/sym4.png")},
        {name: "地块5", img: require("@/assets/img/nysy/sym5.png")},
        {name: "地块6",img: require("@/assets/img/nysy/sym6.png")},
      ],
      hjdata: [
        { name: "虫害", number: 60, unit: "%"},
        { name: "病害", number: 40, unit: "%"},
        {name: "土壤状态", number: 50, unit: "%"},
        { name: "土壤成分", number: 80, unit: "%"},
      ],
      xsdata: [{ name: "玉米"}, { name: "小麦"}, { name: "大豆"}, { name: "花生"}, { name: "芝麻"}, { name: "油菜"}, { name: "马铃薯"}],
      startVal: 0,
      xsindex: 0,
      showDiv:true
    });

    // 在 onMounted 中初始化地图
    onMounted(() => {});

    // 返回上一页
    function tabZuowu(index){
      state.showDiv = false; // 点击后先隐藏div
      state.xsindex = index
      setTimeout(() => {
        state.showDiv = true; // 200ms后再重新显示div（模拟刷新）
      }, 200);
    }

    onUnmounted(() => {});
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });

</script>
<style lang="less" scoped>
 .footer{
    width: 100%;
    height: 30px;
    line-height: 30px;
    color: #fff;
    text-align: center;
    font-size: 30px;
    position: fixed;
    bottom: 30px;
    left: 0;
    z-index: 10000;
    font-weight: bold;
    }
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
::v-deep .d-player-state {
  top: 50%;
  margin-top: -25px;
}
::v-deep .d-icon {
  font-size: 20px !important;
}
::v-deep .d-player-wrap .d-player-control {
  height: 30px;
}

.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  overflow: hidden;
  background: url("../assets/img/gbzntyj/qixiang1/bj.jpg") no-repeat top center;
  background-size: 100% 100%;
  .content {
    width: 100%;
    height: calc(100% - 174px);
    position: absolute;
    top: 174px;
    // border: #fff 1px solid;
    display: flex;
    padding-bottom: 100px;
    .subTit1{
      width: 100%;
      height: 130px;
      line-height: 60px;
      background: url("../assets/img/nysy/xbtd.png") no-repeat center bottom;
      color: #fff;
      font-size: 40px;
      margin: 20px auto 0;
      span{
        background: linear-gradient(to bottom, #fff 25%, #FFD791 95%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: bold;


      }
    }
    .subTit2{
      background: url("../assets/img/nysy/xbtc.png") no-repeat left bottom;
    }
    .left {
      width: 2115px;
      height: 100%;
      margin: 0 10px;
      // border: #fff 1px solid;
      display: flex;
      flex-direction: column;
      border: 1px solid;
    }
    .middle{
      width: 2130px;
      height:100%;
      margin: 50px 50px;
      display: flex;
      align-items: center;
      img{
        width: 100%;
        height: 1199px;
      }
    }
  }
  .echarts{
    width: 100%;
    flex: 1;
  }

//右
    .right {
      width: 2115px;
      height: 100%;
      margin: 0 10px;
      display: flex;
      flex-direction: column;

      }
  }

@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes left1Img {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes titIcon {
  /*引用动画名称*/
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(180deg);
    animation-delay: 5s;
  }
  100% {
    transform: rotateY(0);
  }
}
</style>
